module.exports = __webpack_public_path__ + "img/home_web_08.e5f2667f.png";